import { saveAs } from 'file-saver'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { Card } from '@/components/Elements'
import { FileInput, Input, Select, DatePicker } from '@/components/Form'
import { useAdminFunction } from '@/features/adminFunction/useAdminFunction'
import { OfferDocumentTypes } from '@/features/offers/constants'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { Box, Button, VStack } from '@chakra-ui/react'
import { toast } from 'react-toastify'
import useSystemVariable from '@/features/systemVariables/useSystemVariable.js'
import { useEffect, useState } from 'react'
import useFile from '@/features/files/useFile.js'
import useConfig from '../useConfig'
import { ConfigType } from '../config.enum'

const UserManualCard = ({ title, userManualType = false }) => {
  const methods = useForm()
  const dispatch = useDispatch()
  const { useFetchConfigByType, useUpdateConfig } = useConfig()
  const { useFetchFile } = useFile()
  const updateConfig = useUpdateConfig()
  const { data: fetchUserManualResponse } = useFetchConfigByType(
    userManualType === 'external' ? ConfigType.EXTERNAL_USER_MANUAL : ConfigType.INTERNAL_USER_MANUAL
  )
  const configId = fetchUserManualResponse?.id ?? ''

  const { data: userManualFile } = useFetchFile(fetchUserManualResponse?.mainValue)

  const { useDownloadFile } = useFile()
  const downloadFile = useDownloadFile()

  const [defaultFile, setDefaultFile] = useState(null)

  useEffect(() => {
    if (userManualFile?.data) {
      methods.setValue('file', userManualFile?.data)
    }
  }, [userManualFile?.data])

  const onSubmit = async (data) => {
    try {
      if (!configId) {
        throw new Error('Missing Config Id')
      }

      dispatch(showLoadingOverlay())

      const response = await updateConfig.mutateAsync({ id: configId, data: { mainValue: data?.file?._id ?? '' } })
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <Card title={title}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box p={5}>
            <VStack>
              <FileInput
                label="User Manual"
                name="file"
                fileType={
                  userManualType === 'external'
                    ? OfferDocumentTypes.EXTERNAL_USER_MANUAL
                    : OfferDocumentTypes.INTERNAL_USER_MANUAL
                }
                canUpload
                isRequired={true}
                isRow
                accept=".pdf"
                defaultFile={defaultFile}
              />
            </VStack>
            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Card>
  )
}

export default UserManualCard
